/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import {
  ShadowTableColumn,
  TablePlayerWellness,
  StickyTableHead,
  ArrowHolderSummary,
  ColumnContainerSummary,
  TeamNamePopUp,
  SortPopUp,
  RadiosContainer,
  ArrowUp,
  LocationWrapper,
  CheckBoxWrapper,
  PopUpText,
} from './styles';
import {Radio, InputCheckbox} from '..';
import Utils, {deepGet} from '../../utils/api/Utils';
import {Oval} from '../../pages/players/styles';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';
export function Tooltip({data, tooltip}: {data: Array<any>; tooltip: any}) {
  if (tooltip?.visible) {
    if (data?.length > 0) {
      return (
        <TeamNamePopUp posX={tooltip.posX} posY={tooltip.posY}>
          {data?.map((item, index) => {
            if (index === data.length - 1) {
              return <div key={item + 'popUp' + tooltip.posX}>{item}</div>;
            } else {
              return <div key={item + 'popUp' + tooltip.posX}>{item + ','}</div>;
            }
          })}
        </TeamNamePopUp>
      );
    } else {
      return <></>;
    }
  } else {
    return <></>;
  }
}
function PopUp({
  table,
  useTable,
  data,
  visible,
  popup_id,
  includeAlerts,
  status,
  filterFunc,
  type,
}: {
  table: Array<any>;
  useTable: any;
  data: Array<string>;
  visible: string;
  popup_id: string;
  includeAlerts?: boolean;
  status?: Array<string>;
  filterFunc?: any;
  type?: number;
}) {
  const [reverse, useReverse] = useState<boolean>(true);
  const UTILS = new Utils();
  const sortOptions = [reverse, useTable, table];
  const [radio, useRadio] = useState<any>({one: false, two: false});
  const [check, useCheck] = useState<any>({zone_1: false, zone_2: false, zone_3: false});

  useEffect(() => {
    UTILS.HandleSorted(data, sortOptions);
    if (status) buildFilter();
  }, [radio]);
  useEffect(() => {
    if (status) buildFilter();
  }, [check]);
  function buildFilter() {
    let filters: Array<string> = [];
    Object.values(check).map((item, idx) => {
      if (item) {
        filters.push(Object.keys(check)[idx]);
      }
      return item;
    });

    filters = filters.map(item => {
      if (item === 'zone_1') {
        item = 'Watch';
      }
      if (item === 'zone_2') {
        item = 'Warning';
      }
      if (item === 'zone_3') {
        item = 'Medical';
      }
      return item;
    });

    useTable(table.filter(item => filterFunc(deepGet(item, status), filters)));
  }
  function HandleRadioSort(e: any): void {
    if (e.target.id === 'descendent') {
      const descendent = {one: true, two: false};
      useReverse(false);
      useRadio(descendent);
    } else if (e.target.id === 'ascendent') {
      const ascendent = {one: false, two: true};
      useReverse(true);
      useRadio(ascendent);
    }
  }
  if (visible === popup_id) {
    return (
      <SortPopUp>
        <ArrowUp />
        <RadiosContainer onChange={HandleRadioSort}>
          <Radio title="High-Low" name="tableInfo" id="descendent" checked={false} dynamicActive={radio.one} size={'21px'} />
          <Radio title="Low-High" name="tableInfo" id="ascendent" checked={false} dynamicActive={radio.two} size={'21px'} />
        </RadiosContainer>
        {includeAlerts && (
          <>
            <hr style={{border: '0.5px solid rgba(240, 240, 240, 1)', marginBottom: '12px'}} />

            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_1} onClick={() => useCheck({...check, zone_1: !check.zone_1})} />
              <PopUpText onClick={() => useCheck({...check, zone_1: !check.zone_1})}>Watch</PopUpText>
              <Oval size={'16'} color={'yellow'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_2} onClick={() => useCheck({...check, zone_2: !check.zone_2})} />
              <PopUpText onClick={() => useCheck({...check, zone_2: !check.zone_2})}>Warning</PopUpText>
              <Oval size={'16'} color={'red'} />
            </CheckBoxWrapper>
            {type === 1 && (
              <CheckBoxWrapper>
                <InputCheckbox checked={check.zone_3} onClick={() => useCheck({...check, zone_3: !check.zone_3})} />
                <PopUpText onClick={() => useCheck({...check, zone_3: !check.zone_3})}>Medical</PopUpText>
                <Oval size={'16'} color={'blue'} />
              </CheckBoxWrapper>
            )}
          </>
        )}
      </SortPopUp>
    );
  } else {
    return <></>;
  }
}
const PopUpGenerator = ({name, title, data, changeFunction, location, visible, toggleFunction, filterFunc, type}) => {
  return (
    <StickyTableHead topPosition="64px" topPositionResponsive="41px">
      <span onClick={() => toggleFunction(name)}>{title}</span>

      <PopUp
        table={data}
        useTable={changeFunction}
        data={location}
        popup_id={name}
        visible={visible}
        includeAlerts={true}
        status={location}
        filterFunc={filterFunc}
        type={type}
      />
    </StickyTableHead>
  );
};

export default ({dataTableContent, dataCy}: {dataTableContent: Array<any>; dataCy?: string}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [popUp, usePopup] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const UTILS = new Utils();

  useEffect(() => {
    useTable(dataTableContent);
  }, [dataTableContent]);
  function togglePopUp(selectedPopUp: string) {
    if (selectedPopUp === popUp) {
      usePopup('');
      useSort('');
    } else {
      usePopup(selectedPopUp);
      useSort('');
    }
  }
  function changeTable(e) {
    useTable([...e]);
  }
  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortIsoDate(params, sortOptions);
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }
  function toggleSortNumber(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }
  function handleProp(data) {
    return (data !== null ||data !== undefined) ? data : '-';
  }

  function handleDate(date) {
    return date ? new Date(date).toLocaleDateString('en-US') : '-';
  }
  function SortingTableHead({title = '', attr, location, sortFunction}) {
    return (
      <StickyTableHead topPosition="64px" onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickyTableHead>
    );
  }
  function takeInitials(string) {
    return string
      .split(' - ')
      .map(element => element[0])
      .join('');
  }
  function playerPainLocation(item) {
    if (item?.dailyCheckIn?.arm?.location?.length > 1) {
      return item?.dailyCheckIn?.arm?.location?.map((element, idx) => {
        if (idx === item?.dailyCheckIn?.arm?.location?.length - 1) {
          return <span key={element + idx + item._id}>{takeInitials(element)}</span>;
        } else {
          return <span key={element + idx + item._id}>{takeInitials(element) + ', '}</span>;
        }
      });
    } else if (item?.dailyCheckIn?.arm?.location?.length === 1) {
      return item?.dailyCheckIn?.arm?.location?.map((element, idx) => {
        if (element.includes('Other') || element.includes('other')) {
          return <span key={element + idx + item._id}>Other</span>;
        } else {
          return <span key={element + idx + item._id}>{element}</span>;
        }
      });
    } else if (!item?.dailyCheckIn?.arm?.location?.length) {
      return <span>-</span>;
    }
  }
  function playerPainLocationTwo(item) {
    if (item?.painReport?.throwing?.location?.length > 1) {
      return item?.painReport?.throwing?.location?.map((element, idx) => {
        if (idx === item?.painReport?.throwing?.location?.length - 1) {
          return <span key={element + idx + item._id}>{takeInitials(element)}</span>;
        } else {
          return <span key={element + idx + item._id}>{takeInitials(element) + ', '}</span>;
        }
      });
    } else if (item?.painReport?.throwing?.location?.length === 1) {
      return item?.painReport?.throwing?.location?.map((element, idx) => {
        if (element.includes('Other') || element.includes('other')) {
          return <span key={element + idx + item._id}>Other</span>;
        } else {
          return <span key={element + idx + item._id}>{element}</span>;
        }
      });
    } else if (!item?.painReport?.throwing?.location?.length) {
      return <span>-</span>;
    }
  }
  function armStatus(armStatus) {
    if (armStatus > 3 && armStatus < 6) return <Oval size={'8'} color={'yellow'} margin={'0px 0px 0px 3px'} />;
    else if (armStatus > 1 && armStatus < 4) return <Oval size={'8'} color={'red'} margin={'0px 0px 0px 3px'} />;
    else if (armStatus <= 1) return <Oval size={'8'} color={'blue'} margin={'0px 0px 0px 3px'} />;
  }
  function bodyStatus(bodystats) {
    if (bodystats > 3 && bodystats < 6) return <Oval size={'8'} color={'yellow'} margin={'0px 0px 0px 3px'} />;
    else if (bodystats > 0 && bodystats < 4) return <Oval size={'8'} color={'red'} margin={'0px 0px 0px 3px'} />;
  }
  function sleepStatus(sleepStatus) {
    if (sleepStatus > 3 && sleepStatus < 6) return <Oval size={'8'} color={'yellow'} margin={'0px 0px 0px 3px'} />;
    else if (sleepStatus > 0 && sleepStatus < 4) return <Oval size={'8'} color={'red'} margin={'0px 0px 0px 3px'} />;
  }
  const GenerateColumn = ({index, item}) => {
    const [tooltip, useTooltip] = useState({visible: false, posX: 0, posY: 0});
    function changeTooltip(event, value) {
      useTooltip({visible: value, posX: event.clientX, posY: event.clientY});
    }
    const [tooltipTwo, useTooltipTwo] = useState({visible: false, posX: 0, posY: 0});
    function changeTooltipTwo(event, value) {
      useTooltipTwo({visible: value, posX: event.clientX, posY: event.clientY});
    }
    return (
      <tr key={index}>
        <td>{handleDate(item?.dailyCheckIn?.arm?.date)}</td>
        <ShadowTableColumn>
          {handleProp(item?.dailyCheckIn?.arm?.current)}
          {armStatus(item?.dailyCheckIn?.arm?.current)}
        </ShadowTableColumn>
        <LocationWrapper
          onMouseEnter={e => changeTooltip(e, true)}
          onMouseLeave={e => changeTooltip(e, false)}
          onWheel={() => useTooltip({...tooltip, visible: false})}>
          {playerPainLocation(item)}
          <Tooltip data={item?.dailyCheckIn?.arm?.location} tooltip={tooltip} />
        </LocationWrapper>

        <ShadowTableColumn>{handleProp(item?.dailyCheckIn?.arm?.avg7Days)}</ShadowTableColumn>
        <td>
          {handleProp(item?.dailyCheckIn?.body?.current)}
          {bodyStatus(item?.dailyCheckIn?.body?.current)}
        </td>
        <td>{handleProp(item?.dailyCheckIn?.body?.avg7Days)}</td>
        <ShadowTableColumn>
          {handleProp(item?.dailyCheckIn?.sleep?.current)}
          {sleepStatus(item?.dailyCheckIn?.sleep?.current)}
        </ShadowTableColumn>
        <ShadowTableColumn>{handleProp(item?.dailyCheckIn?.sleep?.avg7Days)}</ShadowTableColumn>
        <td>{handleDate(item?.painReport?.throwing?.date)}</td>
        <td>{handleProp(item?.painReport?.throwing?.throwingRelated)}</td>
        <LocationWrapper
          theme="light"
          onMouseEnter={e => changeTooltipTwo(e, true)}
          onMouseLeave={e => changeTooltipTwo(e, false)}
          onWheel={() => useTooltipTwo({...tooltip, visible: false})}>
          {playerPainLocationTwo(item)}
          <Tooltip data={item?.painReport?.throwing?.location} tooltip={tooltipTwo} />
        </LocationWrapper>

        <td>{handleProp(item?.painReport?.throwing?.painScale)}</td>
        <ShadowTableColumn>{handleDate(item?.painReport?.testing?.date)}</ShadowTableColumn>
        <ShadowTableColumn>{handleProp(item?.painReport?.testing?.testingPain)}</ShadowTableColumn>
      </tr>
    );
  };
  function handleFilterArm(value, filter) {
    switch (filter) {
      case 'Watch':
        if (value > 3 && value < 6) return true;
        else return false;
      case 'Warning':
        if (value > 1 && value < 4) return true;
        else return false;

      case 'Medical':
        if (value <= 1) return true;
        else return false;

      default:
        return false;
    }
  }

  function filterArm(value, filter) {
    let pass = false;
    let passed: Array<any> = [];
    filter.map(filtered => passed.push(handleFilterArm(value, filtered)));
    passed.map(val => {
      if (val) {
        pass = true;
      }
      return val;
    });
    if (filter.length === 0) {
      pass = true;
    }

    return pass;
  }
  function handleFilterBody(value, filter) {
    switch (filter) {
      case 'Watch':
        if (value > 3 && value < 6) return true;
        else return false;
      case 'Warning':
        if (value > 0 && value < 4) return true;
        else return false;

      default:
        return false;
    }
  }

  function filterBody(value, filter) {
    let pass = false;
    let passed: Array<any> = [];
    filter.map(filtered => passed.push(handleFilterBody(value, filtered)));
    passed.map(val => {
      if (val) {
        pass = true;
      }
      return val;
    });
    if (filter.length === 0) {
      pass = true;
    }

    return pass;
  }
  function closeSorts() {
    usePopup('');
    useSort('');
  }

  return (
    <TablePlayerWellness data-cy={dataCy}>
      <thead>
        <tr>
          <StickyTableHead topPosition="0px" colSpan={8}>
            DAILY CHECK IN
          </StickyTableHead>
          <StickyTableHead topPosition="0px" colSpan={6}>
            PAIN REPORTED
          </StickyTableHead>
        </tr>
        <tr>
          <StickyTableHead topPosition="21px" colSpan={4}>
            ARM
          </StickyTableHead>
          <StickyTableHead topPosition="21px" colSpan={2}>
            BODY
          </StickyTableHead>
          <StickyTableHead topPosition="21px" colSpan={2}>
            SLEEP
          </StickyTableHead>
          <StickyTableHead topPosition="21px" colSpan={4}>
            THROWING
          </StickyTableHead>
          <StickyTableHead topPosition="21px" colSpan={2}>
            TESTING
          </StickyTableHead>
        </tr>
        <tr>
          <SortingTableHead title="Date" attr="armdate" location={['dailyCheckIn', 'arm', 'date']} sortFunction={toggleSortDate} />

          <PopUpGenerator
            name="currentArm"
            title="Current"
            data={dataTableContent}
            location={['dailyCheckIn', 'arm', 'current']}
            visible={popUp}
            changeFunction={changeTable}
            toggleFunction={togglePopUp}
            filterFunc={filterArm}
            type={1}
          />

          <SortingTableHead
            title="Location"
            attr="armlocation"
            location={['dailyCheckIn', 'arm', 'location', 0]}
            sortFunction={toggleSortString}
          />
          <SortingTableHead
            title="7 Day Avg."
            attr="armavg"
            location={['dailyCheckIn', 'arm', 'avg7Days']}
            sortFunction={toggleSortNumber}
          />
          <PopUpGenerator
            name="currentBody"
            title="Current"
            data={dataTableContent}
            location={['dailyCheckIn', 'body', 'current']}
            visible={popUp}
            changeFunction={changeTable}
            toggleFunction={togglePopUp}
            filterFunc={filterBody}
            type={2}
          />

          <SortingTableHead
            title="7 Day Avg."
            attr="bodyavg"
            location={['dailyCheckIn', 'body', 'avg7Days']}
            sortFunction={toggleSortNumber}
          />
          <PopUpGenerator
            name="currentSleep"
            title="Current"
            data={dataTableContent}
            location={['dailyCheckIn', 'sleep', 'current']}
            visible={popUp}
            changeFunction={changeTable}
            toggleFunction={togglePopUp}
            filterFunc={filterBody}
            type={2}
          />

          <SortingTableHead
            title="7 Day Avg."
            attr="sleepavg"
            location={['dailyCheckIn', 'sleep', 'avg7Days']}
            sortFunction={toggleSortNumber}
          />
          <SortingTableHead
            title="Date"
            attr="throwingdate"
            location={['painReport', 'throwing', 'date']}
            sortFunction={toggleSortDate}
          />
          <SortingTableHead
            title="Throwing Related"
            attr="throwingrelated"
            location={['painReport', 'throwing', 'throwingRelated']}
            sortFunction={toggleSortString}
          />
          <SortingTableHead
            title="Location"
            attr="throwinglocation"
            location={['painReport', 'throwing', 'location', 0]}
            sortFunction={toggleSortString}
          />
          <SortingTableHead
            title="Pain Scale"
            attr="painscale"
            location={['painReport', 'throwing', 'painScale']}
            sortFunction={toggleSortNumber}
          />
          <SortingTableHead title="Date" attr="testingdate" location={['painReport', 'testing', 'date']} sortFunction={toggleSortDate} />
          <SortingTableHead
            title="Testing Pain"
            attr="testingPain"
            location={['painReport', 'testing', 'testingPain']}
            sortFunction={toggleSortString}
          />
        </tr>
      </thead>
      <tbody onClick={() => closeSorts()}>
        {table?.length > 0 ? (
          table?.map((item, index) => {
            return <GenerateColumn index={index} item={item} key={'wellnessplayers' + item + index} />;
          })
        ) : (
          <tr>
            <td colSpan={15}>No Data</td>
          </tr>
        )}
      </tbody>
    </TablePlayerWellness>
  );
};
